import Vue from "vue";
import $vuetifyEn from "vuetify/src/locale/en";
import en from "@/common/assets/locales/en.json";
import VueI18n from "vue-i18n";
import * as _ from "lodash";

Vue.use(VueI18n);

export const AppI18n = new VueI18n({
  locale: "en",
  silentTranslationWarn: true,

  messages: {
    en: Object.assign(
      {
        $vuetify: $vuetifyEn,
      },
      en
    ),
  },
});

export function loadCustomerLocale(): Promise<void> | undefined {
  if (process.env.VUE_APP_CUSTOMER) {
    return import(`@/common/assets/locales/customer/${process.env.VUE_APP_CUSTOMER}/${AppI18n.locale}.json`).then(
      (messages) => {
        const localeMessage = { ...AppI18n.getLocaleMessage(AppI18n.locale) };
        _.merge(localeMessage, messages);
        AppI18n.setLocaleMessage(AppI18n.locale, localeMessage);
      }
    );
  }
}

loadCustomerLocale();
